import { render, staticRenderFns } from "./LayOut.vue?vue&type=template&id=60c13d73&"
import script from "./LayOut.vue?vue&type=script&lang=js&"
export * from "./LayOut.vue?vue&type=script&lang=js&"
import style0 from "./LayOut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports